export default (location: any) => {
  const { pathname } = location;

  try {
    (window as any).analytics.page(null, pathname, {
      path: pathname,
    });
  } catch (error) {
    window.Raven.captureException(error, {
      extra: {
        pathname,
      },
    });
  }
};
